import { FC, ReactElement } from 'react'

interface Props {
  color?: 'cyan' | 'purple' | 'green' | 'red' | 'blue' | 'yellow'
  className?: string
  children?: ReactElement | string
}

const Chip: FC<Props> = ({ color, className, children }) => {
  return (
    <div
      className={`chip ${color ? `_${color}` : ''} ${className ?? ''}`.trim()}
    >
      {children}
    </div>
  )
}

export default Chip
